import { MARKETS, COMPANY } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { CTABand } from "@/components/CTABand";
import { PageHero, usePageMeta } from "@/components/PageHero";

const Markets = () => {
  usePageMeta(
    "Markets We Serve | Bass Crane Service, Richmond VA",
    "Bass Crane supports residential and commercial contractors, steel erectors, carpentry, HVAC, and roofing contractors across Richmond, VA and Virginia."
  );

  return (
    <div data-testid="markets-page">
      <PageHero
        eyebrow="Markets We Serve"
        titleLines={["Who We", "Serve"]}
        intro="From residential builds to structural steel, Bass Crane brings certified operators and the right equipment to the trades that keep Virginia building."
        image="/images/header-markets.jpg"
        imageAlt="Crane boom rising beside a Richmond high-rise"
        testId="markets-hero"
      />

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28 bg-white" data-testid="markets-grid">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#E5E7EB]">
          {MARKETS.map((m, i) => (
            <Reveal key={m.num} delay={(i % 3) * 0.08}>
              <div className="relative flex flex-col h-full min-h-[260px] p-8 md:p-10 border-r border-b border-[#E5E7EB] bg-white">
                <span className="font-mono-plex text-sm text-[#1C3172] mb-10">{m.num}</span>
                <h3 className="text-2xl md:text-3xl uppercase text-[#1A1A1A] mb-4">{m.title}</h3>
                <p className="text-[#5B6270] text-base leading-relaxed">{m.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand
        heading="On Your Crew?"
        sub={`Call us anytime, 24/7, to schedule a lift for your trade.`}
      />
    </div>
  );
};

export default Markets;
